import React, { useEffect } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import bannerImage from "../../../components/images/digital-skills-training-banner-june-12-2025.jpeg";

//svgs
import {
  Time as TimeIcon,
  VoiceIcon,
  Location,
  Calender,
  BookOpen,
} from "../../../components/svgs";
import {
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";
import useDigitalSkillsTraining from "./hooks/useDigitalSkillsTraining";

const iconMap = {
  time: TimeIcon,
  calendar: Calender,
  location: Location,
  edit: VoiceIcon,
  bookmark: BookOpen,
};

const DigitalSkillsTrainingHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "StanbicDigitalSkillsRegistrationHome",
        firebase_screen_class: "StanbicDigitalSkillsRegistrationHome",
      })
    );
  }, []);

  const {
    background,
    history,
    digitalSkillsregistrationDetails,
    hasRegistered,
    isLoading,
    isRegistrationLimitReached,
  } = useDigitalSkillsTraining();

  return (
    <MainHolder>
      <Children>
        <BackButton onClick={() => history.goBack()} />
        <FeatureHeader
          image={bannerImage}
          title={[" Digital Skills", "Training program"]}
          background={"#fff"}
          secondaryBackground={"#fff"}
        ></FeatureHeader>

        <Body>
          <div
            style={{
              boxSizing: "border-box",
              padding: "10px 15px 70px 15px",
            }}
          >
            {digitalSkillsregistrationDetails?.points.map(
              ({ icon, title, description, link }) => (
                <IconList
                  Icon={iconMap[icon]}
                  title={title}
                  link={link}
                  key={title}
                  description={description}
                  color={background}
                />
              )
            )}
            <HorizontalLine />

            <div>
              <StyledText
                size={14}
                style={{ fontFamily: "MTNMedium", margin: "0 0 4px 0" }}
              >
                About the event
              </StyledText>
              <StyledText
                size={12}
                style={{ fontFamily: "MTNRegular", margin: "0 0 10px 0" }}
              >
                Join our Digital Skills Training program aimed at empowering
                young professionals with essential digital skills to navigate
                today's tech-driven world. Whether you're looking to enhance
                your career or start a new venture, this event offers key
                insights and tools to help you succeed.
              </StyledText>
            </div>

            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                background: "#fff",
                borderTop: "1px solid #ddd",
              }}
            >
              <div style={{ padding: "10px 30px" }}>
                <DynamicButton
                  onClick={() => {
                    if (hasRegistered === false)
                      history.push("/digital-skills-training/register");
                  }}
                  label={determineButtonEnabledText({
                    isLoading,
                    hasRegistered,
                  })}
                  // disabled={hasRegistered || isLoading}
                  disabled={true}
                  color={hasRegistered === false ? background : "#0FAF4B"}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </Body>
      </Children>
    </MainHolder>
  );
};

const IconList = ({ Icon, title, description, color, link }) => (
  <div style={{ display: "flex", alignItems: "top", marginBottom: "15px" }}>
    <div
      style={{
        width: "16px",
        marginRight: "10px",
      }}
    >
      <Icon fill={color} width={16} height={16} />
    </div>
    <div>
      <StyledText
        size={14}
        style={{ fontFamily: "MTNBold", margin: "0 0 2px 0" }}
      >
        {title}
      </StyledText>
      <StyledText size={12} style={{ fontFamily: "MTNRegular", margin: "0" }}>
        {description}
      </StyledText>
      {link ? (
        <a
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontFamily: "MTNRegular",
            fontSize: 14,
            textDecoration: "underline",
            color: "black",
          }}
        >
          {link.name}
        </a>
      ) : null}
    </div>
  </div>
);

function determineButtonEnabledText(params) {
  const { isLoading, hasRegistered } = params;

  if (isLoading) {
    return "Checking registration status...";
  }

  // if (isRegistrationLimitReached) {
  //   return "No Seats Left";
  // }

  if (hasRegistered) {
    return "You are registered!";
  }

  return "Register";
}

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

export default DigitalSkillsTrainingHome;
